import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import OptionsData from '@/ts/OptionsData';
import store from '@/store';
import axios from 'axios';
import { Mutations, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';

@Module({name: 'Options', namespaced: true})
export default class Options extends VuexModule {
    public options: OptionsData[] = [];
    public optionsMap: { [index: number]: number } = {};
    public activeOptionIndex: number = null;
    public optionImageData: string = '';

    @Mutation
    public RESET_OPTIONS_STORE_STATE(): void {
        this.options           = [];
        this.optionsMap        = {};
        this.activeOptionIndex = null;
        this.optionImageData   = '';
    }

    get allOptions() {
        return this.options;
    }

    get selectedOptions() {
        return this.options.filter((item) => {
            return item.selected === true;
        });
    }

    get getActiveOption() {
        return this.options[this.optionsMap[this.activeOptionIndex]];
    }

    get getTempItems() {
        return Options.state.tempItems;
    }

    @Action
    public FETCH_OPTIONS() {
        axios.get(Endpoints.Options.OPTION)
            .then((response) => {
                if (response.data != null && response.data.length > 0) {
                    for (const option of response.data) {
                        store.commit(Mutations.ADD_OPTION, {
                            id: option.id,
                            productName: option.productName,
                            description: option.description,
                            price: option.price,
                            color: option.color,
                            serialNumber: option.serialNumber,
                            category: option.category,
                            defaultOption: option.defaultOption,
                        });
                    }
                }
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });

        return;
    }

    @Action
    public POST_OPTION_IMAGE(optionImageData: File) {
        const headers = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };

        const requestPayload = new FormData();
        requestPayload.append('optionImageData', optionImageData);

        axios.post(Endpoints.Options.OPTION_IMAGE_POST, requestPayload, headers)
            .then((response) => {

            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Mutation
    public UPDATE_ACTIVE_OPTION(optionId: number | null) {
        this.activeOptionIndex = optionId;
    }

    @Mutation
    public ADD_OPTION(option: OptionsData) {
        let arrayIndex = null;

        if (!this.optionsMap.hasOwnProperty(option.id)) {
            arrayIndex = this.options.push(option) - 1;

            this.optionsMap[option.id] = arrayIndex;
        } else {
            arrayIndex = this.optionsMap[option.id];
        }

        return arrayIndex;
    }

    @Mutation
    public SELECT_ITEM(itemId: number) {
        const option = this.options[this.optionsMap[itemId]];

        for (const item of this.options) {
            if (item.category === option.category) {
                item.selected = false;
            }
        }

        this.options[this.optionsMap[itemId]].selected = true;
    }

    @Mutation
    public DESELECT_ITEM(itemId: number) {
        const option = this.options[this.optionsMap[itemId]];

        for (const item of this.options) {
            if (item.category === option.category) {
                item.selected = true;
            }
        }

        this.options[this.optionsMap[itemId]].selected = false;
    }
}

